import Plugin from './Plugin';
import {mergeTagsContentStyle} from './style';

export default Plugin;
export {
  mergeTagsContentStyle,
}
